import React from 'react';
import { Shield, Lock, FileCheck, Globe } from 'lucide-react';

const SecurityFooter = () => {
  return (
    <div className="bg-gray-50 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-6 py-8">
        <div className="flex flex-wrap items-center justify-center gap-8 text-sm text-gray-600">
          <div className="flex items-center gap-2">
            <Shield className="w-5 h-5 text-green-600" />
            <span className="font-medium">SOC 2 Type II</span>
          </div>
          
          <div className="flex items-center gap-2">
            <Globe className="w-5 h-5 text-blue-600" />
            <span className="font-medium">GDPR Compliant</span>
          </div>
          
          <div className="flex items-center gap-2">
            <Lock className="w-5 h-5 text-purple-600" />
            <span className="font-medium">256-bit Encryption</span>
          </div>
          
          <div className="flex items-center gap-2">
            <FileCheck className="w-5 h-5 text-orange-600" />
            <span className="font-medium">CCPA Compliant</span>
          </div>
        </div>
        
        <div className="text-center mt-4 text-xs text-gray-500">
          Your data is never sold or shared. All customer information is encrypted and stored securely.
        </div>
      </div>
    </div>
  );
};

export default SecurityFooter; 